export function formatDateTime(value: string | null): string {
  if (!value) {
    return 'Never';
  }

  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    timeZoneName: 'short',
  }).format(new Date(value));
}

export function formatTargetTypeLabel(value: 'external_url' | 'internal_url' | 'study'): string {
  switch (value) {
    case 'external_url':
      return 'External URL';
    case 'internal_url':
      return 'Internal URL';
    case 'study':
      return 'Study';
    default:
      return value;
  }
}

export function formatLinkStateLabel(value: 'active' | 'archived'): string {
  return value === 'active' ? 'Active' : 'Archived';
}

export function formatResolutionStateLabel(value: 'ready' | 'awaiting_publish'): string {
  return value === 'ready' ? 'Ready' : 'Awaiting publish';
}
